import React from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  Input,
  Label,
  Container,
  Row,
} from "reactstrap";
import { Modal } from "react-bootstrap";
import Loading from "../../loader/loader";

const RakBankModal = ({
  onHide,
  bankDetails,
  approveClicked,
  show = false,
  deleteClicked,
  delButtonloading,
  data,
  showRakBankModal,
  rakTableList,
  bankrecordStatus,
  approveButtonloading,
}) => {
  return (
    <Modal
      onHide={onHide}
      show={show}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="rak-beneficiary-modal"
      animation={false}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          <h1 style={{ textAlign: "center" }}>Bank Details</h1>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="modal-body-content">
          <Col lg="5" className="label-bank-details">
            Bank Name
          </Col>
          <Col lg="1">:</Col>
          <Col lg="6"> {bankDetails && bankDetails.bankName}</Col>
        </Row>
        <Row className="modal-body-content">
          <Col lg="5" className="label-bank-details">
            Country
          </Col>
          <Col lg="1">:</Col>
          <Col lg="6"> {bankDetails && bankDetails.country}</Col>
        </Row>
        <Row className="modal-body-content">
          <Col lg="5" className="label-bank-details">
            Type
          </Col>
          <Col lg="1">:</Col>
          <Col lg="6"> {bankDetails && bankDetails.transferType}</Col>
        </Row>
        <Row className="modal-body-content">
          <Col lg="5" className="label-bank-details">
            Branch Name
          </Col>
          <Col lg="1">:</Col>
          <Col lg="6"> {bankDetails && bankDetails.bankBranchName}</Col>
        </Row>
        <Row className="modal-body-content">
          {bankDetails && bankDetails.country === "PK" ? (
            <Col lg="5" className="label-bank-details">
              IBAN
            </Col>
          ) : (
            <Col lg="5" className="label-bank-details">
              IFSC Code
            </Col>
          )}
          <Col lg="1">:</Col>
          <Col lg="6"> {bankDetails && bankDetails.ifscCode}</Col>
        </Row>
        <Row className="modal-body-content">
          <Col lg="5" className="label-bank-details">
            Account Number
          </Col>
          <Col lg="1">:</Col>
          <Col lg="6"> {bankDetails && bankDetails.accountNumber}</Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        {bankrecordStatus && bankrecordStatus === "PENDING" ? (
          <Button
            variant="secondary"
            color="primary"
            disabled={approveButtonloading}
            onClick={() => {
              approveClicked(bankDetails && bankDetails.id);
            }}
          >
            {approveButtonloading ? (
              <Loading color="white" width="15px" height="15px" />
            ) : (
              "Approve"
            )}
          </Button>
        ) : null}
        <Button
          variant="primary"
          color="danger"
          disabled={delButtonloading}
          onClick={() => {
            deleteClicked(bankDetails && bankDetails.id);
          }}
        >
          {delButtonloading ? (
            <Loading color="white" width="15px" height="15px" />
          ) : (
            "Delete"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RakBankModal;
